'use client';

import FormText from '@/components/form/FormText/FormText';
import FaIcon, { faSearch } from '@/components/icon/FaIcon/FaIcon';
import utilsStyles from '@/styles/modules/utils.module.scss';
import { Route } from 'next';
import { useRouter } from 'next/navigation';
import { useForm } from 'react-hook-form';
import styles from './ECommerceTextSearchForm.module.scss';

function ECommerceTextSearchForm({
  query,
  placeholder,
}: {
  query?: string;
  placeholder?: string;
}) {
  const router = useRouter();
  const { handleSubmit, getValues, control } = useForm({
    mode: 'onChange',
    defaultValues: {
      searchText: query || '',
    },
  });

  const textSearch = () => {
    const params = new URLSearchParams(location.search);
    if (getValues('searchText').length > 0) {
      params.set('q', getValues('searchText'));
    } else {
      params.delete('q');
    }
    router.replace(`${location.pathname}?${params.toString()}` as Route);
  };

  const onChangeText = () => {
    textSearch();
  };

  const submitText = async () => {
    textSearch();
  };

  return (
    <>
      <div className={styles.header}>
        <div className={styles.textSearchWrapper}>
          <form onSubmit={handleSubmit(submitText)}>
            <FormText
              name='searchText'
              control={control}
              outlined
              placeholder={placeholder}
              prefix={
                <div className={styles.searchIcon}>
                  <FaIcon icon={faSearch} size='xl' />
                </div>
              }
              onChange={onChangeText}
              isSmall={true}
            ></FormText>
          </form>
        </div>
      </div>
      {query && <p className={`${utilsStyles.textSmall} ${utilsStyles.mtXSmall}`}>“{query}”の検索結果</p>}
    </>
  );
}

export default ECommerceTextSearchForm;
